import React, { ComponentType } from 'react';

import { useSelector, shallowEqual } from 'react-redux';
import { createSelector } from 'reselect';

import {
  MenuItem,
  ContainerNavigationNext,
} from '@atlassian/bitbucket-navigation';

import { Repository } from 'src/components/types';
import { memoRepoLink } from 'src/sections/repository/components/navigation-repo-link';
import { getCurrentRepository } from 'src/selectors/repository-selectors';

import { useRepositoryNavigationProps } from '../containers/use-repository-navigation-props';

type RepositoryNavigationProps = {
  headerLinkComponent?: ComponentType<any>;
  linkComponent: ComponentType<any>;
  menuItems: MenuItem[];
  selectedMenuItem?: MenuItem;
  containerType?: string;
};

const getPieces = createSelector(getCurrentRepository, (repo: Repository) => {
  if (!repo) {
    return {};
  }
  return {
    isPrivate: repo.is_private,
    name: repo.name,
    fullName: repo.full_name,
    landingPage: repo.landing_page,
    htmlUrl: repo.links.html.href,
    avatarUrl: repo.links.avatar.href,
  };
});

const RepositoryNavigationNext = React.memo(
  (props: RepositoryNavigationProps) => {
    const repositoryNavigationProps = useRepositoryNavigationProps();
    const {
      isPrivate = false,
      name = '',
      fullName = '',
      landingPage = '',
      htmlUrl = '',
      avatarUrl = '',
    } = useSelector(getPieces, shallowEqual);

    const hasRepo = !!name && !!fullName && !!htmlUrl;
    const RepoLink: React.FunctionComponent<any> = memoRepoLink(
      name,
      fullName,
      landingPage,
      htmlUrl
    );
    const headerLinkComponent = hasRepo ? RepoLink : undefined;

    return (
      <ContainerNavigationNext
        {...props}
        {...repositoryNavigationProps}
        containerType="repository"
        headerLinkComponent={headerLinkComponent}
        isGlobalContext={false}
        isPrivate={isPrivate}
        containerName={name}
        containerHref={htmlUrl}
        containerLogo={avatarUrl}
      />
    );
  }
);

export default RepositoryNavigationNext;
